// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 913 ? "default" : chunkId) + "-legacy." + {"386":"94da765c","913":"eee95530"}[chunkId] + ".js";
};